module.exports = __webpack_public_path__ + "./rain-light.272fb79b7c99a89b9891f2d596aabecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/rain-light.png
// module id = 8OvN
// module chunks = app